<template>
        <li>
          <img v-if = "!shipOwner" class ='icons-container'
            :src="require('@/assets/icons/icon-reserve.svg')"
            alt="container icon"
          />
          <img  v-else class ='icons-container'
            :src="require('@/assets/icons/icon-container.svg')"
            alt="container icon"
          />
          <div class = "container-data">
            <!--<router-link tag="h6" class="pointer" @click.native="setContainer()"  to="/containerview" exact>
              <b>{{name}}</b>
            </router-link>-->
            <div tag="h6" class="pointer" @click="setContainer()">
              <b>{{name}}</b>
            </div>
            <p class = "container-status">{{capitalizeFirstLetter(state)}}</p>
             <!-- <img class ='icons-container-alert'
              :src="require('@/assets/icons/bell_blue.svg')"
              alt="bell icon"
            /> -->
            <!-- <p class = "container-alert ">Contenedor cargado</p> -->
          </div>
          <div class = "container-maersk ">
            <p v-if="shipOwner" class = "m-0"> {{shipOwner}} </p> 
            <p  v-else class = "m-0"> -------- </p> 
              <img class ='icons-delete'
              :src="require('@/assets/icons/icon-delete.svg')"
              v-bind:class="{ 'hide': !authorized('cargador')}"
              alt="delete icon"
              @click="deleteExpedient"
            />
          </div>
        </li>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import {capitalizeFirstLetter} from '@/services/helper'
import { deleteData } from '@/services/api'

export default {
  name: 'Containers',
  props: ['name','state','shipOwner', 'expedienteId'],
  data() {
    return {
    }
  },
  computed: { 
    ...mapGetters("user",{
      authorized: 'authorized',
    })  
  },
  mounted () {
  },
  methods: {
    setContainer: function () {
      this.$store.commit('set_view_name', [this.name])
      this.$store.commit('container/set_container_id', this.expedienteId)
      this.$router.push('ContainerView')
      
      //this.$store.commit('container/set_container_status', this.state)
    },
    capitalizeFirstLetter: capitalizeFirstLetter,
    deleteExpedient: function() {
      deleteData('expedientes/',this.expedienteId)
    }
  }
}
</script>

<style lang= "scss" >

.container-data {
  display: inline-block;
  margin: 0px 0px 0px 20px;
  padding: 9px 0px 0px 0px;
}

.container-status {
  font-size: 0.9rem;
  color: $container-status;
}

.container-alert{
  display: inline-block;
  font-size: 0.9rem;
  color: $container-alert;
}

.container-maersk {
  float: right;
  margin: 0px 10px 0px 0px;
  color: $container-maersk;
}

</style>
